module.exports = __webpack_public_path__ + "static/media/Ellipse_blue.73faf1bf.svg";